// src/CiqlerDetail.js
import React from "react";
import "./driveguard.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function DriveGuardDetail() {
  return (
    <div>
      <nav className="navbar">
        <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <h1>Ziad Aly</h1>
        </Link>
      </nav>
      <div className="mainbackground">
        <div className="driveguard-project-detail notion-style">
          <div
            className="driveguard-video-container"
            style={{ marginLeft: "300px" }}
          >
            <video
              controls
              width="50%"
              src={`${process.env.PUBLIC_URL}/./DriveGuard.mp4`}
            />
          </div>
          <div className="detail-content">
            <div className="text-container">
              <h1>DriveGuard</h1>
              <div className="projectImaged">
                <img src={`${process.env.PUBLIC_URL}/DriveGuradlogo.jpeg`} />
              </div>
              <h2>Problem Statement</h2>
              <p>
                Drowsy driving significantly contributes to fatal accidents, yet
                most vehicles lack advanced drowsiness detection technology.
                This limited availability, combined with drivers' inability to
                recognize their own fatigue, increases the risk of preventable
                crashes.
              </p>
              <h2>Value Propestation</h2>
              <p>
                DriveGuard offers a universally compatible, retrofit solution
                that empowers drivers to enhance vehicle safety with real-time
                drowsiness detection and alerts. Built on a robust
                machine-learning model, the native app leverages publicly
                available datasets such as the Drowsy Detection Dataset and
                Facial Expression of Fatigue (FEF) to ensure high accuracy.
                Using a convolutional neural network, the app processes frames
                from the camera feed in real time, identifying key facial
                expressions associated with fatigue to provide timely and
                reliable safety alerts.
              </p>
              <h2>Technology</h2>
              <ul>
                <li>
                  <strong>Python:</strong> Flask, TensorFlow, Pandas
                </li>
                <li>ReactNative</li>
                <li>
                  <strong>AWS:</strong> EC2
                </li>
              </ul>
              <h2>Team</h2>
              <ul>
                <ul>
                  <li style={{ marginLeft: "25px" }}>
                    <a
                      href="https://www.linkedin.com/in/can-a-31260038/"
                      style={{ color: "inherit" }}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Can Aktaran
                    </a>
                  </li>
                  <li style={{ marginLeft: "25px" }}>
                    <a
                      href="https://www.linkedin.com/in/hillel-tladi-12532a166/"
                      style={{ color: "inherit" }}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Hillel Tladi{" "}
                    </a>
                  </li>

                  <li style={{ marginLeft: "25px" }}>
                    <a
                      href="https://www.linkedin.com/in/paul-fromm-351315157/"
                      style={{ color: "inherit" }}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Paul Fromm
                    </a>
                  </li>
                  <li style={{ marginLeft: "25px" }}>
                    <a
                      href="https://www.linkedin.com/in/sebastian-brucker-679244170/"
                      style={{ color: "inherit" }}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Sebastian Brucker
                    </a>
                  </li>
                </ul>
              </ul>
              <div>
                <h2>Status</h2>
                <p style={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      width: "8px",
                      height: "8px",
                      backgroundColor: "#6C757D",
                      borderRadius: "50%",
                      display: "inline-block",
                      marginRight: "8px",
                    }}
                  ></span>
                  Offline, The backend got deployed for couple of days for
                  showcasing the app on our phones.
                </p>
              </div>
              {/* Add more detailed information here if needed */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DriveGuardDetail;
